import { selectCarDayOverview, selectDriverOverview, selectDriverWorkRank, selectCompanyCar, selectCompanyDriver, selectCompanyWorkRank, selectCityCar } from "../../api/config/modules/HomeMasterKong";

const state = {
  selectCarDayOverview: {},
  selectDriverOverview: {},
  selectDriverWorkRank: {},
  selectCompanyCar: {},
  selectCompanyDriver: {},
  selectCompanyWorkRank: {},
  selectCityCar: {}
};

const mutations = {
  SET_SELECTCARDAYOVERVIEW: (state, selectCarDayOverview) => {
    state.selectCarDayOverview = selectCarDayOverview;
  },
  SET_SELECTDRIVEROVERVIEW: (state, selectDriverOverview) => {
    state.selectDriverOverview = selectDriverOverview;
  },
  SET_SELECTDRIVERWORKRANK: (state, selectDriverWorkRank) => {
    state.selectDriverWorkRank = selectDriverWorkRank;
  },
  SET_SELECTCOMPANYCAR: (state, selectCompanyCar) => {
    state.selectCompanyCar = selectCompanyCar;
  },
  SET_SELECTCOMPANYDRIVER: (state, selectCompanyDriver) => {
    state.selectCompanyDriver = selectCompanyDriver;
  },
  SET_SELECTCOMPANYWORKRANK: (state, selectCompanyWorkRank) => {
    state.selectCompanyWorkRank = selectCompanyWorkRank;
  },
  SET_SELECTCITYCAR: (state, selectCityCar) => {
    state.selectCityCar = selectCityCar;
  },
};

const actions = {
  GET_SELECTCARDAYOVERVIEW: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarDayOverview(data)
        .then((res) => {
          commit("SET_SELECTCARDAYOVERVIEW", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVEROVERVIEW: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverOverview(data)
        .then((res) => {
          commit("SET_SELECTDRIVEROVERVIEW", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERWORKRANK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverWorkRank(data)
        .then((res) => {
          commit("SET_SELECTDRIVERWORKRANK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCOMPANYCAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCompanyCar(data)
        .then((res) => {
          commit("SET_SELECTCOMPANYCAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCOMPANYDRIVER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCompanyDriver(data)
        .then((res) => {
          commit("SET_SELECTCOMPANYDRIVER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCOMPANYWORKRANK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCompanyWorkRank(data)
        .then((res) => {
          commit("SET_SELECTCOMPANYWORKRANK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCITYCAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCityCar(data)
        .then((res) => {
          commit("SET_SELECTCITYCAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
